/* eslint-disable no-param-reassign,no-plusplus,no-underscore-dangle,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerHistory', [
    '$rootScope',
    'DesignerHistoryChange',

    '$timeout',

    function ($rootScope, DesignerHistoryChange, $timeout) {
      function DesignerHistory(designer) {
        this.designer = designer;
        this.changes = [];
        this.currentSaveIndex = 0;
      }

      DesignerHistory.prototype = Object.create({});

      DesignerHistory.prototype.undo = function () {
        if (this.hasUndo()) {
          this.currentSaveIndex--;
          this.changeData();
        }
      };

      DesignerHistory.prototype.redo = function () {
        if (this.hasRedo()) {
          this.currentSaveIndex++;
          this.changeData();
        }
      };

      DesignerHistory.prototype.hasUndo = function () {
        return this.changes.length > 1 && this.currentSaveIndex > 0;
      };

      DesignerHistory.prototype.hasRedo = function () {
        return this.currentSaveIndex < this.changes.length - 1;
      };

      DesignerHistory.prototype.save = function (message) {
        const historyChange = new DesignerHistoryChange(message);

        if (this.currentSaveIndex < this.changes.length) {
          this.changes.splice(this.currentSaveIndex + 1, this.changes.length - 1 - this.currentSaveIndex);
        }

        const packageData = this.designer.package.getData();

        historyChange.setPackageData(packageData);

        this.changes.push(historyChange);
        this.currentSaveIndex = this.changes.length - 1;

        this.designer.package.validateComponents();
        this.designer.package.dataChanged = this.isDataChanged(packageData);

        $rootScope.$broadcast(DESIGNER_EVENTS.HISTORY_CHANGE, {
          hasUndo: this.hasUndo(),
          hasRedo: this.hasRedo(),
          packageDataChanged: this.designer.package.dataChanged,
        });
      };

      DesignerHistory.prototype.isDataChanged = function () {
        return this.currentSaveIndex > 0;
      };

      const changeData = function (_this) {
        const historyChange = _this.changes[_this.currentSaveIndex];

        const historyPackageData = historyChange.getPackageData();

        _this.designer.package.setData(historyPackageData);
        _this.designer.package.dataChanged = _this.isDataChanged(historyPackageData);
        _this.designer.package.update();

        $rootScope.$broadcast(DESIGNER_EVENTS.HISTORY_CHANGE, {
          hasUndo: _this.hasUndo(),
          hasRedo: _this.hasRedo(),
          packageDataChanged: _this.designer.package.dataChanged,
        });

        _this.designer.package.checkEffected();
      };

      let promise = null;

      DesignerHistory.prototype.changeData = function () {
        const _this = this;

        if (promise === null) {
          changeData(_this);
        } else {
          $timeout.cancel(promise);
          promise = $timeout(function () {
            changeData(_this);
            promise = null;
          }, 1000);
        }
      };

      return DesignerHistory;
    },
  ]);
})(window.angular);
